import { Show, type JSX } from 'solid-js';
import { Glyph } from '~/components/glyph';

interface WindowProps {
  title: string;
  /** Color dot on the title bar. */
  dot?: 'action' | 'data' | 'hostile' | '';
  /** Trailing slot on the right of the header (status indicator, etc.) */
  headerTrailing?: JSX.Element;
  onClose?: () => void;
  style?: JSX.CSSProperties;
  children: JSX.Element;
}

/** Modal "OS window" container matching the .window class in tokens.css. */
export function Window(props: WindowProps) {
  return (
    <div class="window" style={props.style}>
      <header>
        <span class={`dot ${props.dot ?? ''}`} />
        <span>{props.title}</span>
        <span style={{ flex: 1 }} />
        {props.headerTrailing}
        <Show when={props.onClose}>
          <button
            onClick={() => props.onClose?.()}
            style={{
              background: 'transparent',
              border: 'none',
              color: 'var(--fg-mute)',
              cursor: 'pointer',
              padding: 0,
              display: 'flex',
            }}
            aria-label="Close"
          >
            <Glyph name="x" size={14} />
          </button>
        </Show>
      </header>
      {props.children}
    </div>
  );
}
